// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyArchiveWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyArchiveWebApiHandler_archive } from '@zg-rentals/ts-rental-manager-api-client';

import type { ListingAlias } from '@zg-rentals/ts-rental-manager-api-client';

interface ArchiveParams {
  listingAlias: ListingAlias;
}

export interface RentalManagerUserPropertyArchiveWebApiHandler_archive_Args {
  getParams: ArchiveParams;
}

export type RentalManagerUserPropertyArchiveWebApiHandler_archive_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyArchiveWebApiHandler_archive_Args
>;

/**
 * Archive a listing and its dupes
 */
export const useRentalManagerUserPropertyArchiveWebApiHandler_archive = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyArchiveWebApiHandler_archive_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyArchiveWebApiHandler_archive_Args) =>
      RentalManagerUserPropertyArchiveWebApiHandler_archive(args.getParams, httpClient),
  });
};
